import { BaseService } from '../../infra/base.service'
import type { AppointmentsByPerson } from './appointments-by-person'
import type { SchedulerReportsRepository } from './reports.repository'

export class SchedulerReportsService extends BaseService<AppointmentsByPerson> {
    constructor(private rep: SchedulerReportsRepository) {
        super(rep)
    }

    async appointmentsByPerson(from: Date, to: Date): Promise<AppointmentsByPerson[]> {
        return await this.rep.appointmentsByPerson(from, to)
    }
}
